export default __webpack_public_path__ + "static/media/logo-sci-short.71942353.svg";